import { gql } from '@apollo/client';

export default gql`
  query getEvents(
    $categoryId: String
    $departmentId: String
    $employeeId: String
    $projectId: String
    $resourseId: String
    $customerId: String
    $contractId: String
    $status: Int
    $start: Date
    $end: Date
    $due: Boolean
    $noinvoice: Boolean
  ) {
    getEvents(
      categoryId: $categoryId
      departmentId: $departmentId
      employeeId: $employeeId
      projectId: $projectId
      resourseId: $resourseId
      customerId: $customerId
      contractId: $contractId
      status: $status
      start: $start
      end: $end
      due: $due
      noinvoice: $noinvoice
    ) {
      ok
      error
      data {
        _id
        id
        branch
        title
        desc
        startDate
        endDate
        duration
        allDay
        rRule
        reminder
        exDate
        allowDrag
        location {
          lat
          lng
        }
        groupId
        locationLink
        address
        houseno
        autoNo
        docNo
        temp
        priority
        amount
        status
        steps
        nots
        activenots
        smss
        activesmss

        bonos
        overtime
        absent
        cashin
        teamMembers

        customerId
        customerName
        customerNameAr
        customerPhone

        departmentId
        departmentName
        departmentNameAr
        departmentColor

        employeeId
        employeeName
        employeeNameAr
        employeeColor
        employeePhone
        workersIds

        projectId
        projectName
        projectNameAr
        projectColor
        resourseId
        resourseName
        resourseNameAr
        resourseColor

        contractId
        contractName
        contractNameAr

        retypeId
        retypeName
        retypeNameAr
        retypeColor

        retype2Id
        retype2Name
        retype2NameAr
        retype2Color

        invoiceId
        link
        sent
        paid
        invoiced
        procs

        attachments

        refNo
        refType
        userId
        createdAt
        updatedAt
      }
    }
  }
`;
